module.exports = __webpack_public_path__ + "img/logo.da10773d.png";